const signupFormModal = document.querySelector('.js-signup-form-modal');

document.querySelectorAll('.js-signup-form-trigger').forEach(trigger => {
  trigger.addEventListener('click', () => {
    signupFormModal.classList.add('is-active');
    document.getElementById('user_organization_attributes_name').focus();
  })
})

const closeBtn = document.querySelector('.js-signup-form-modal-close');
closeBtn.addEventListener('click', () => {
  signupFormModal.classList.remove('is-active');
})

window.addEventListener('keydown', (event) => {
  switch (event.key) {
    case  'Escape':
      signupFormModal.classList.remove('is-active');
  }
})
